<template>
	<div style="width: 100%;height: 100%;">
		<div >
			<el-carousel arrow="always" height="600px">
				<el-carousel-item >
					<router-link to="Sterilization-robot" target="_blank">
					<img src="../../../public/pic/product/srt/A.png" style="width: 100%;height: 600px;"/>
					</router-link>
				</el-carousel-item>
				<el-carousel-item >
					<router-link to="UVC-robot" target="_blank">
					<img src="../../../public/index/B.png" style="width: 100%;height: 600px;"/>
					</router-link>
				</el-carousel-item>
				<el-carousel-item >
					<router-link to="Sterilizer" target="_blank">
					<img src="../../../public/pic/idp/1.jpg" style="width: 100%;height: 600px;"/>
					</router-link>
				</el-carousel-item>
				<el-carousel-item >
					<router-link to="Food-delivery-robot" target="_blank">
					<img v-show="this.$i18n.locale == 'zh'" src="../../../public/index/C.png" style="width: 100%;height: 600px;"/>
					<img v-show="this.$i18n.locale == 'en'" src="../../../public/pic/product/fooddelivery/C1.png" style="width: 100%;height: 600px;"/>
					</router-link>
				</el-carousel-item>
				<el-carousel-item >
					<router-link to="Receptionist-robot" target="_blank">
					<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/D.png" style="width: 100%;height: 600px;"/>
					<img v-show="this.$i18n.locale == 'en'" src="../../../public/pic/product/welcome/D1.png" style="width: 100%;height: 600px;"/>
					</router-link>
				</el-carousel-item>
				<el-carousel-item >
					<router-link to="Companion-robot" target="_blank">
					<img src="../../../public/index/E.png" style="width: 100%;height: 600px;"/>
					</router-link>
				</el-carousel-item>
			</el-carousel>
		</div>
		<div class="center">
			<div style="width: 80%;">
				<div style="margin: 100px;">
					<p style="font-size: 40px;font-weight: bold;">{{ $t('lang.index1')}}</p>
					<br /><br />
					<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/srt/srtzh1.png" style="width: 60%;"/>
					<img v-show="this.$i18n.locale == 'en'" src="../../../public/pic/product/srt/srten11.png" style="width: 60%;"/>
				</div>
				<div style="margin-top: 100px;">
					<div style="width: 100%;">
						<video controls ref="video" >
							<source src="../../../public/index/7a1bcf67ff6ac495c85ce24833cd04f6.mp4" type="video/mp4">
						</video>
					</div>
				</div>
				<br /><br /><br /><br /><br /><br />
				<div style="display: none;">
					<div style="font-size: 40px;"> 
						<p>{{ $t('lang.News')}}</p>
					</div>&nbsp;&nbsp;&nbsp;
					<el-row :gutter='20' style="margin-top: 40px;">
						<el-col :span="6" >
							<router-link to="dynamic_details" target="_blank">
								<div class="grid-content bg-purple-dark" >
									<img src="../../../public/pic/company/C1.png" style="width: 200px;height: 150px;"/>
									<p class="p" style="font-size: 20px;">深圳全智能（智能消毒机器人）三种机型，总有你需要的款式</p>
									<p >2020-09-07</p>
								</div>
							</router-link>
						</el-col>
						<el-col :span="6" >
							<router-link to="" target="_blank">
								<div class="grid-content bg-purple-dark">
									<img src="../../../public/pic/company/C2.png" style="width: 200px;width: 150px;"/>
									<p class="p" style="font-size: 20px;">深圳全智能科技智能消毒机器人——通过欧盟CE、北美FCC认证和GT生物检测</p>
									<p >2020-07-08</p>
								</div>
							</router-link>
						</el-col>
						<el-col :span="6" >
							<router-link to="" target="_blank">
								<div class="grid-content bg-purple-dark" >
									<img src="../../../public/pic/company/C3.png" style="width: 200px;height: 150px;"/>
									<p class="p" style="font-size: 20px;">全国找合作：深圳全智能科技——诚征国内省级代理商</p>
									<p >2020-06-12</p>
								</div>
							</router-link>
						</el-col>
						<el-col :span="6" >
							<router-link to="" target="_blank">
								<div class="grid-content bg-purple-dark">
									<img src="../../../public/pic/company/C4.png" style="width: 200px;height: 150px;"/>
									<p class="p" style="font-size: 20px;">一款10倍人工效率的智能消毒机器人，国内外抢手【深圳全智能】</p>
									<p >2020-06-08</p>
								</div>
							</router-link>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
		//url: ['../../../public/index/A.png','../../../public/index/B.png','../../../public/index/C.png','../../../public/index/D.png','../../../public/index/E.png']
	data() {
		return {
			url: ['../../../public/index/A.png','../../../public/index/B.png','../../../public/index/C.png','../../../public/index/D.png','../../../public/index/E.png'],
		};
	},
	created(){
	},
	methods:{
	}
}	
</script>

<style>	
.p{
	overflow: hidden;white-space: nowrap;text-overflow: ellipsis;
}
.el-carousel__item h3 {
	font-size: 18px;
	opacity: 0.75;
	line-height: 300px;
	margin: 0;
}

.el-carousel__item:nth-child(2n) {
	background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
	background-color: #d3dce6;
}
.time {
    font-size: 13px;
  }
  
  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  
  .clearfix:after {
      clear: both
  }
</style>
